import { EventEngineEventsService } from '@amzn/event-engine-events-sdk';
import { formatString, useInterval } from '@amzn/event-engine-js-utils';
import React, { useCallback, useState } from 'react';
import { i18nStrings } from 'utils/constants';

import compareEventState from '../utils/compare-event-state';
import getEventDuration from '../utils/get-event-duration';

export const DEFAULT_UPDATE_INTERVAL = 1000;

export interface EventDurationMessageProps {
    eventData: EventEngineEventsService.ParticipantGetEventResponse;
    updateIntervalMS?: number;
    isIntervalPaused?: boolean;
}

const EventDurationMessage = ({
    eventData,
    updateIntervalMS = DEFAULT_UPDATE_INTERVAL,
    isIntervalPaused,
}: EventDurationMessageProps) => {
    const [eventDuration, setEventDuration] = useState(
        getEventDuration(eventData, updateIntervalMS)
    );
    const updateEventDuration = useCallback(() => {
        eventData &&
            setEventDuration(getEventDuration(eventData, updateIntervalMS));
    }, [eventData, updateIntervalMS]);

    useInterval(
        updateEventDuration,
        !isIntervalPaused &&
            eventData &&
            compareEventState(eventData.stateRuntime, 'start_success') >= 0 &&
            eventData.stateRuntime !== 'pause_success'
            ? updateIntervalMS
            : null
    );

    return (
        <>
            {eventDuration
                ? formatString(
                      i18nStrings.event.notifications.eventInProgress.content,
                      eventDuration
                  )
                : i18nStrings.event.notifications.eventEnded.content}
        </>
    );
};

export default EventDurationMessage;
